'use strict';

angular.module('TurneroApp').service('seguridadService', [
    '$q',
    '$http',
    '$cookies',
    '$localStorage',
    'portal',
    function ($q, $http, $cookies, $localStorage, portal) {
        var _this = this;

        //Se crea promesas de usuario, tokencidi y tokencentro
        var usuarioDefer = $q.defer();
        var tokenCidiDefer = $q.defer();
        var tokenCentroDefer = $q.defer();

        this.permisos = '';
        this.tokenCidi = null;
        this.tokenCentro = null;

        this.getUsuario = function () {
            return usuarioDefer.promise;
        }

        this.removeCookies = function () {
            $cookies.remove('Turnero');
            $cookies.remove('VeDiRefreshToken');
            $cookies.remove('VeDiToken');
            $cookies.remove('VeDiSesionId');
        };

        //Deslogueo de autenticación - Elimina autenticación de tokenCiDi y tokenCentro
        this.logOut = function () {
        	try{
        		usuarioDefer = $q.defer();
        		tokenCidiDefer = $q.defer();
        		tokenCentroDefer = $q.defer();
        		this.permisos = '';
        		this.tokenCidi = null;
        		this.tokenCentro = null;

        		delete $localStorage.TurneroApp_Authorization;
        		delete $localStorage.TurneroApp_Authorization_Centro;
        	}catch(err) {
        		//Block of code to handle errors
        	}
          
        }

        //Obtiene token cuando un request utiliza tokenCiDi
        this.getTokenCidi = function () {
            if (this.tokenCidi) {
                //retorna la promesa
                return tokenCidiDefer.promise;
            }

            //Si la autorización y el token existe se retorna los datos
            if ($localStorage.TurneroApp_Authorization) {
                this.token = $localStorage.TurneroApp_Authorization.token;
                //Llamaremos al método resolve para indicar que ya tenemos la información que se solicitó y por lo tanto que la promesa está resuelta
                tokenCidiDefer.resolve(this.token);
                if ($localStorage.TurneroApp_Authorization.usuario != null) {
                    //Llamaremos al método resolve para indicar que ya tenemos la información que se solicitó y por lo tanto que la promesa está resuelta
                    usuarioDefer.resolve($localStorage.TurneroApp_Authorization.usuario);
                    this.permisos = $localStorage.TurneroApp_Authorization.usuario.permisos;
                }
            } else {//Si la autorización y el token no existe, se solicita autorizar
                //"grant_type" indica el tipo de concesión que se presenta a cambio de un token de acceso, en nuestro caso es una cookie.
                this.tokenCidi = $http.get(portal.getUrlServer() + 'token'/*, 'grant_type=cookie', {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }*/).then(function (response) {

                    var auxNombre = response.data.nombreUsuario.indexOf(",") != -1 ? response.data.nombreUsuario.split(",")[1] : response.data.nombreUsuario;
                    var auxApellido = response.data.nombreUsuario.indexOf(",") != -1 ? response.data.nombreUsuario.split(",")[0] : "";

                    var usuario = {
                        nombre: response.data.nombreUsuario,
                        CUIL: response.data.cuil,
                        TieneRepresentados: response.data.tieneRepresentados,
                        permisos: response.data.permisos,
                        datos: {
                            nombre: auxNombre,
                            apellido: auxApellido
                        }
                    };
                    _this.permisos = response.data.permisos;

                    //Guardamos en localstorage el token de cidi y datos del usuario
                    $localStorage.TurneroApp_Authorization = {
                        token: response.data.access_token,
                        usuario: usuario
                    };

                    //Llamaremos al método resolve para indicar que ya tenemos la información que se solicitó y por lo tanto que la promesa está resuelta
                    tokenCidiDefer.resolve(response.data.access_token);
                    usuarioDefer.resolve(usuario);
                });
            }

            //retorna la promesa
            return tokenCidiDefer.promise;
        }

        //Obtiene token cuando un request utiliza tokenCentro (Solo llamador, recepcion)
        this.getTokenCentro = function () {
            if (this.tokenCentro) {
                //retorna la promesa
                return tokenCentroDefer.promise;
            }

            if ($localStorage.TurneroApp_Authorization_Centro) {
                this.token = $localStorage.TurneroApp_Authorization_Centro;
                //Llamaremos al método resolve para indicar que ya tenemos la información que se solicitó y por lo tanto que la promesa está resuelta
                tokenCentroDefer.resolve(this.token);
            } else {
                //"grant_type" indica el tipo de concesión que se presenta a cambio de un token de acceso, en nuestro caso es una cookie.
                this.tokenCentro = $http.get(portal.getUrlServer() + 'token'/*, 'grant_type=cookie', {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }*/).then(function (response) {
                    //Guardamos en localstorage el token del centro
                    $localStorage.TurneroApp_Authorization_Centro = response.data.access_token;

                    //Llamaremos al método resolve para indicar que ya tenemos la información que se solicitó y por lo tanto que la promesa está resuelta
                    tokenCentroDefer.resolve(response.data.access_token);
                });
            }

            //retorna la promesa
            return tokenCentroDefer.promise;
        }
    }]);



// WEBPACK FOOTER //
// ./app/components/general/seguridadService.js